<template>
  <v-container>
    <v-row>
      <v-col>
        <v-btn small to="/cycles" tile elevation="0" color="transparent" style="color: #000" class="pl-0 pr-0 mb-5">
          <v-icon>mdi-arrow-left</v-icon>
          Retour
        </v-btn>

        <v-card>
          <!-- Cycle toolbar -->
          <v-toolbar dark color="#1B8A62">
            <v-toolbar-title>Cycle {{ item.name }}</v-toolbar-title>

            <v-spacer></v-spacer>

            <v-btn icon @click="redirectToEditCycle" v-if="canManageCurrentCycle">
              <v-icon>edit</v-icon>
            </v-btn>

            <template v-slot:extension>
              <v-row>
                <v-col>
                  <div v-if="item.destinationType === DestinationTypes.DISCIPLINE">Destination: Spécifique</div>
                  <div v-else-if="item.destinationType === DestinationTypes.PUBLIC">Destination: Transversal</div>
                  <div v-else>ERREUR</div>
                </v-col>

                <v-col v-if="item.discipline">
                  Discipline:
                  <span>
                    {{ item.discipline.name }}
                  </span>
                </v-col>
              </v-row>
            </template>
          </v-toolbar>

          <v-card-text>
            <!-- Cycle description -->
            <v-row>
              <v-col cols="6">
                <v-row class="no-padding-sides">
                  <v-col cols="12">
                    <v-label><b>Description</b></v-label>
                    <p v-html="item.description"></p>
                  </v-col>
                </v-row>

                <v-row class="no-padding-sides row-left" v-if="item.advancedMode && item.ageGroups && item.ageGroups.length > 0">
                  <v-col cols="12">
                    <v-label
                      ><b>{{ ageGroupCustomTitle }}</b></v-label
                    >
                    <v-row>
                      <v-col class="no-padding-sides">
                        <v-chip v-for="ageGroup in item.ageGroups" class="ma-2" :key="ageGroup.id">
                          {{ ageGroup.title }}
                        </v-chip>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>

                <v-row class="no-padding-sides row-left" v-if="item.advancedMode && item.practiceTypes && item.practiceTypes.length > 0">
                  <v-col cols="12">
                    <v-label
                      ><b>{{ practiceTypeCustomTitle }}</b></v-label
                    >
                    <v-row>
                      <v-col class="no-padding-sides">
                        <v-chip v-for="practiceType in item.practiceTypes" class="ma-2" :key="practiceType.id">
                          {{ practiceType.title }}
                        </v-chip>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>

                <v-row class="no-padding-sides row-left" v-if="item.advancedMode && item.complementaryInformation">
                  <v-col cols="12">
                    <v-label><b>Informations compémentaires</b></v-label>
                    <p v-html="item.complementaryInformation"></p>
                  </v-col>
                </v-row>
              </v-col>

              <v-col>
                <v-label><b>Niveau de difficulté</b></v-label>
                <v-rating color="#1B8A62" background-color="#1B8A62" readonly v-model="item.difficulté" empty-icon="mdi-hexagon-outline" full-icon="mdi-hexagon" />
                <p v-if="item.advancedMode" v-html="item.descDifficulté"></p>

                <v-label><b>Intensité</b></v-label>
                <v-rating color="#1B8A62" background-color="#1B8A62" readonly v-model="item.intensité" empty-icon="mdi-square-outline" full-icon="mdi-square" />

                <p v-if="item.advancedMode" v-html="item.descIntensité"></p>
              </v-col>

              <v-col>
                <v-label><b>Observables</b></v-label>

                <div v-for="(observable, index) in item.observable" v-bind:key="index">
                  {{ observable.name }}
                </div>
              </v-col>
            </v-row>

            <h3>Récap des sessions</h3>

            <v-card class="mb-5 pb-2" v-for="(etape, index) in item.etape" v-bind:key="index">
              <v-col cols="12">
                <h4 class="font-weight-bold block-title">{{ etape.name }}</h4>
                <span class="font-weight-bold">{{ etape.progression }}</span>
              </v-col>

              <div style="width: 100%; overflow-x: scroll">
                <div class="d-flex">
                  <!-- Sessions cards -->
                  <v-col cols="12" md="8" lg="6" xl="4" v-for="(session, idx) in etape.session" v-bind:key="idx" style="border-right: 1px solid #ccc">
                    <div class="text-center">
                      <!-- Actions container -->
                      <v-row>
                        <v-col cols="2" v-if="canManageCurrentCycle">
                          <!-- Move the session to the left -->
                          <v-tooltip top>
                            <template v-slot:activator="{ on }">
                              <v-icon v-on="on" :disabled="session.index <= 1" @click="moveSessionIndex(etape.session, session, true)" color="#8ec67e" large
                                >mdi-menu-left</v-icon
                              >
                            </template>
                            <span>Positionner avant</span>
                          </v-tooltip>
                        </v-col>
                        <!-- Session Buttons -->
                        <v-col :cols="canManageCurrentCycle ? 8 : 12">
                          <v-row>
                            <v-col>
                              <!-- View Session Button -->
                              <v-btn icon small :to="`/cycle/${id}/session/${session.id}`">
                                <v-icon small color="#8ec67e">mdi-eye</v-icon>
                              </v-btn>

                              <!-- Delete Session Button -->
                              <v-btn icon small @click="removeSessionFromStep(etape.id, session.id)" v-if="canManageCurrentCycle">
                                <v-icon small color="#8ec67e">delete</v-icon>
                              </v-btn>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col
                              ><!-- Session Title -->
                              <h6 class="font-weight-bold" style="font-size: 16px">
                                {{ session.name }}
                              </h6>
                            </v-col>
                          </v-row>
                        </v-col>
                        <v-col cols="2" v-if="canManageCurrentCycle">
                          <!-- Move the session to the right -->
                          <v-tooltip top>
                            <template v-slot:activator="{ on }">
                              <v-icon
                                v-on="on"
                                :disabled="session.index >= etape.session.length"
                                @click="moveSessionIndex(etape.session, session, false)"
                                color="#8ec67e"
                                large
                                >mdi-menu-right</v-icon
                              >
                            </template>
                            <span>Positionner après</span>
                          </v-tooltip>
                        </v-col>
                      </v-row>
                    </div>
                    <!-- Blocks -->
                    <div v-for="(block, index) in session.block" v-bind:key="index" style="border-bottom: 1px dashed #ccc" class="py-3">
                      <h6 class="font-weight-bold">{{ block.name }}</h6>

                      <div v-if="block.isCircuit">
                        Rép. : {{ block.nbRep }} | Tps réc. :
                        {{ block.tpsRecup }}
                      </div>

                      <div>
                        <draggable :list="block.exercisesSets" @end="endDrag_changeExerciseSetsIndex(block.exercisesSets)">
                          <div v-for="(exercisesSet, index) in block.exercisesSets" v-bind:key="index">
                            <!-- Exercise row -->
                            <v-row>
                              <v-col cols="9">
                                <!-- Drag and drop icon -->
                                <v-tooltip left v-if="canManageCurrentCycle">
                                  <template v-slot:activator="{ on }">
                                    <v-icon v-on="on" small style="padding-right: 2%" class="page__grab-icon">mdi-arrow-all</v-icon>
                                  </template>
                                  <span>Déplacer</span>
                                </v-tooltip>

                                <!-- Exercise Title -->
                                <span>
                                  {{ exercisesSet.exerciseId ? exercisesSet.exercise.title : exercisesSet.ppgExercise.name }}
                                </span>
                              </v-col>
                              <v-col cols="3" class="d-flex justify-end">
                                <!-- View Exercise ENE Button -->
                                <v-btn v-if="exercisesSet.exerciseId" icon small :to="`/exercise/${exercisesSet.exercise.id}/view`">
                                  <v-icon small color="rgb(15, 21, 71)">mdi-eye</v-icon>
                                </v-btn>

                                <!-- View Exercise PPG Button -->
                                <v-btn v-if="exercisesSet.ppgExerciseId" icon small :to="`/exercisePPG/${exercisesSet.ppgExercise.id}`">
                                  <v-icon small color="rgb(15, 21, 71)">mdi-eye</v-icon>
                                </v-btn>

                                <!-- Edit Exercise Button -->
                                <v-btn v-if="exercisesSet.exerciseId && canManageCurrentCycle" icon small :to="`/exercise/${exercisesSet.exercise.id}`">
                                  <v-icon small color="rgb(15, 21, 71)">edit</v-icon>
                                </v-btn>

                                <!-- Delete Exercise Button -->
                                <v-btn
                                  v-if="canManageCurrentCycle"
                                  icon
                                  small
                                  @click="removeExerciseFromBlock(block.id, exercisesSet.exerciseId || exercisesSet.ppgExerciseId, exercisesSet.exerciseId == null)"
                                >
                                  <v-icon small color="rgb(15, 21, 71)">delete</v-icon>
                                </v-btn>
                              </v-col>
                            </v-row>
                          </div>
                        </draggable>
                      </div>
                    </div>
                  </v-col>
                </div>
              </div>
            </v-card>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { getCycleLightAsync, removeSessionFromStepAsync } from "@/api/cycleApi";
import { getDisciplineAsync } from "@/api/disciplinesApi";
import { updateSessionIndexesAsync } from "@/api/sessionApi";
import { updateExercisesSetsIndexesAsync, removeExerciseFromBlockAsync } from "@/api/exerciseApi";
import store from "@/store";
import { DestinationType } from "@/models/enums";
import Draggable from "vuedraggable";
import PermissionsService from "@/services/PermissionsService";
import AuthService from "@/services/AuthService";

export default {
  props: {
    id: {
      type: [String, Number],
    },
  },

  components: {
    Draggable,
  },

  data() {
    return {
      authService: AuthService,
      item: {},
      sessions: [],
      advance: false,
      exercises: [],
      ageGroupCustomTitle: "",
      practiceTypeCustomTitle: "",
      DestinationTypes: DestinationType,
    };
  },

  computed: {
    canViewCurrentCycle() {
      // // Can view own Cycles
      // let canViewOwnCycles = PermissionsService.CyclesPermissionsService.canViewOwnCycles;
      // // Can view all Cycles
      // let canViewAllCycles = PermissionsService.CyclesPermissionsService.canViewAllCycles;
      // return canViewOwnCycles || canViewAllCycles;

      // Allow anonymous to read cycles
      return true;
    },
    canManageCurrentCycle() {
      // Can manage own Cycles
      let canManageOwnCycles = PermissionsService.CyclesPermissionsService.canManageOwnCycles && this.doesCurrentUserOwnCurrentCycle;
      // Can manage all Cycles
      let canManageAllCycles = PermissionsService.CyclesPermissionsService.canManageAllCycles;
      return canManageOwnCycles || canManageAllCycles;
    },
    doesCurrentUserOwnCurrentCycle() {
      return this.item && this.item.userId === this.authService.userId;
    },
    categories: function () {
      if (this.item && this.item.cycleCategory) {
        return this.item.cycleCategory.join(" / ");
      } else {
        return [];
      }
    },
  },

  async mounted() {
    await this.initializeList();

    // Check if the user can see this page
    if (!this.canViewCurrentCycle) {
      store.dispatch("setSnackbar", {
        title: `Non Autorisé`,
        text: `Vous n'êtes pas autorisé à consulter cette ressource.`,
        status: "warning",
        timeout: 2000,
      });

      this.$router.replace("/");
    }

    // Empty only frontend ageGroups property (used to handle ddl selected values)
    this.item.ageGroups = [];
    // Get all the many many cycleAgeGroups values and map only the ageGroup id into ageGroups (filling the ddl with values)
    this.item.cycleAgeGroups.forEach((element) => {
      this.item.ageGroups.push(element.ageGroup);
    });

    // Empty only frontend practiceTypes property (used to handle ddl selected values)
    this.item.practiceTypes = [];
    // Get all the many many cyclePracticeTypes values and map only the ageGroup id into practiceTypes (filling the ddl with values)
    this.item.cyclePracticeTypes.forEach((element) => {
      this.item.practiceTypes.push(element.practiceType);
    });

    // If there is a related discipline, get the custom labels
    if (this.item && this.item.disciplineId) {
      await this.getDisciplineForCustomLabels();
    }
  },

  methods: {
    filterTreeview(list, filterList) {
      if (list.length) {
        list.forEach((obj, idx) => {
          if (obj.children.length) {
            list[idx].children = this.filterTreeview(obj.children, filterList);
          }
        });
        list = list.filter((value) => {
          if (filterList.includes(value.id)) filterList.push(value.parent);
          return filterList.includes(value.id);
        });

        return list;
      }
    },

    // Get the current discipline to use the custom ageGroup title
    async getDisciplineForCustomLabels() {
      if (this.item && this.item.disciplineId) {
        var currentDiscipline = await getDisciplineAsync(this.item.disciplineId);

        if (!currentDiscipline) {
          store.dispatch("setSnackbar", {
            title: "Erreur",
            text: "Impossible de récupérer la discipline auprès du serveur",
            status: "error",
            timeout: 5000,
          });
        } else {
          // age group
          this.ageGroupCustomTitle = currentDiscipline.ageGroupCustomTitle ? currentDiscipline.ageGroupCustomTitle : "Catégories d'âges";
          // PracticeType
          this.practiceTypeCustomTitle = currentDiscipline.practiceTypeCustomTitle ? currentDiscipline.practiceTypeCustomTitle : "Type de pratique";
        }
      }
    },

    // Move the index of a session in its container, then save it
    async moveSessionIndex(sessions, session, isGoingBefore) {
      // If we wanna move it decreasing index
      if (isGoingBefore) {
        var previousSession = sessions.find((s) => s.index == session.index - 1);
        previousSession.index++;
        session.index--;
      }
      // else we wanna move it increasing index
      else {
        var nextSession = sessions.find((s) => s.index == session.index + 1);
        nextSession.index--;
        session.index++;
      }

      // Rewrite the list ordered by index
      sessions = sessions.sort((a, b) => Number(a.index) - Number(b.index));

      // update the sessions with their new indexes
      await updateSessionIndexesAsync(sessions);
    },

    // Update the position index of the exerciseSets after one being dragged and dropped
    async endDrag_changeExerciseSetsIndex(exercisesSets) {
      // Check if the user have the permission to edit the cycle
      if (this.canManageCurrentCycle) {
        exercisesSets.forEach(function (exerciseSets, index) {
          exerciseSets.index = index + 1;
        });

        // Update the exercisesSets with their new indexes
        await updateExercisesSetsIndexesAsync(exercisesSets);
      } else {
        store.dispatch("setSnackbar", {
          title: `Non Autorisé`,
          text: `Vous n'êtes pas autorisé à modifier l'ordre des sessions. Ce changement ne sera pas enregistré.`,
          status: "warning",
          timeout: 2000,
        });
      }
    },

    // redirect to cycle edit page
    redirectToEditCycle() {
      this.$router.push({ name: "GCE", params: { id: this.item.id } });
    },

    // remove an Exercise from an exercise set
    async removeExerciseFromBlock(blockId, exerciseId, isPpgExercise) {
      if (confirm("Etes-vous sûr de retirer cet exercice du block ?")) {
        var result = await removeExerciseFromBlockAsync(blockId, exerciseId, isPpgExercise);

        if (result) {
          store.dispatch("setSnackbar", {
            title: "Exercice retiré",
            text: "L'exercise a bien été retiré.",
            status: "success",
            timeout: 2000,
          });
        }

        await this.initializeList();
      }
    },

    // remove a session from the cycle's set (Etape)
    async removeSessionFromStep(stepId, sessionId) {
      if (confirm("Etes-vous sûr de retirer cette session de l'étape ?")) {
        var result = await removeSessionFromStepAsync(stepId, sessionId);

        if (result) {
          store.dispatch("setSnackbar", {
            title: "Session retirée",
            text: "La session a bien été retirée.",
            status: "success",
            timeout: 2000,
          });
        }

        await this.initializeList();
      }
    },

    // Get page base data
    async initializeList() {
      this.item = await getCycleLightAsync(this.id);

      this.item.etape.forEach((etape) => {
        etape.session.forEach((session) => {
          this.sessions.push(session);
        });
      });
    },
  },
};
</script>

<style lang="css" scoped>
.row-left {
  padding-bottom: 10px;
}
</style>
